import React from 'react';
import hamburger from "../icons/hamburger.svg";
import { updateLocalSetting } from "../Environment";

function Hamburger(props) {
	const onClick = () => {
		updateLocalSetting("isNavActivated", !props.isActivated);
	};

	// let activated = props.isActivated ? "activated" : "not-activated";

	return (
		<div>
			<span className="logo-control my-initial-step">
				<img
					src={hamburger}
					className="hamburger-icon"
					onClick={onClick}
					alt=""
				/>
			</span>
		</div>
	);
}

export default Hamburger;
